// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__3rc0g","logos":"style_logos__1YZfZ","coloredBand":"style_coloredBand__2s1gA","colorHr":"style_colorHr__300-1"};